import { createSelector } from "reselect";
import utils from '../utils';

const getWindowOptions = state => state.Window.Options;
const getDoorOptions = state => state.Door.Options;
const getWindowDesigns = state => state.Window.Designs;
const getConservatoryOptions = state => state.Conservatory.Extras;




const getMainColours = (options, includeRelatedColour = false) => {
    let colours = options.colours;

    let relatedColourIds = [];

    if (!includeRelatedColour) {
        // build an array of colour that we don't want to keep
        for (let i = 0; i < colours.length; i++) {
            let colour = colours[i];

            if (colour.relatedColourId !== 0) {
                relatedColourIds.push(colour.relatedColourId);
            }
        }
    }

    let filteredColours = colours.filter(c => relatedColourIds.indexOf(c.id) === -1);

    filteredColours.sort(utils.sortExtraByRank);

    return filteredColours;
};

export const getMainWindowColours = createSelector(getWindowOptions, options =>
    getMainColours(options)
);

export const getMainConservatoryColours = createSelector(getConservatoryOptions, options =>
    getMainColours(options)
);

export const getAllWindowColours = createSelector(getWindowOptions, options =>
    getMainColours(options, true)
);

export const getDoorLocks = createSelector(getDoorOptions, options => {
    let locks = [];
    for (let extraId in options.extras) {
        let extra = options.extras[extraId];
        if (/Cylinder/i.test(extra.extraGroupName)) {
            locks.push(extra);
        }
    }

    locks.sort(utils.sortExtraByRank);

    return locks;
});

export const getWindowLocks = createSelector(getWindowOptions, options => {
    let locks = [];
    for (let extraId in options.extras) {
        let extra = options.extras[extraId];
        if (/lock/i.test(extra.extraGroupName)) {
            locks.push(extra);
        }
    }

    locks.sort(utils.sortExtraByRank);

    return locks;
});

export const getWindowHandles = createSelector(getWindowOptions, options => {
    let handles = options.extras.filter(e => /handle/i.test(e.extraGroupName));

    handles.sort(utils.sortExtraByRank);

    return handles;
});

export const getMainDoorColours = createSelector(getDoorOptions, options =>
    getMainColours(options)
);
export const getAllDoorColours = createSelector(getDoorOptions, options =>
    getMainColours(options, true)
);

const getCompositeDoorColourByType = (options, type) => {
    let extras = options.extras;

    let colours = [];

    for (var extraId in extras) {
        let extra = extras[extraId];

        let regex = new RegExp(type + " slab colour", "i");

        if (regex.test(extra.extraGroupName)) {
            colours.push({ ...extra, name: extra.name }); // .replace(new RegExp(type + " ", "i"), "")};
        }
    }

    colours.sort(utils.sortExtraByRank);

    return colours;
};

export const getCompositeDoorColours = (state, type) =>
    createSelector(
        getDoorOptions,
        () => type,
        options => getCompositeDoorColourByType(options, type)
    )(state);

export const getWindowDimensionLimits = createSelector(getWindowDesigns, designs => {
    let dimensionLimits = {
        Width: { Min: 999999, Max: 0 },
        Height: { Min: 999999, Max: 0 }
    };

    for (var designId in designs) {
        let design = designs[designId];

        dimensionLimits.Width.Min = Math.min(dimensionLimits.Width.Min, design.minWidth);
        dimensionLimits.Width.Max = Math.max(dimensionLimits.Width.Max, design.maxWidth);
        dimensionLimits.Height.Min = Math.min(dimensionLimits.Height.Min, design.minHeight);
        dimensionLimits.Height.Max = Math.max(dimensionLimits.Height.Max, design.maxHeight);
    }

    return dimensionLimits;
});

export const getWindowWERList = createSelector(getWindowOptions, options => {
    let glass = options.glass[0];

    if (!glass) return [];

    let wers = glass.availableWers.slice(0);

    return wers;
});

export const getDoorWERList = createSelector(getDoorOptions, options => {
    let glass = options.glass[0];

    if (!glass) return [];

    let wers = glass.availableWers.slice(0);

    return wers;
});

export const getCompositeImageList = state => {
    let stackSrc = [];

    stackSrc = state.PreviousPreviews.map(
        pp => "https://s3-eu-west-1.amazonaws.com/truframe/" + pp.src
    );

    return stackSrc;
};

export const getApiKey = createSelector(
    state => state.TradeCustomer,
    tradeCustomer => {
        return tradeCustomer.CustomerGuid;
    }
);

export const getProductIds = createSelector(
    state => state.ProductList,
    products => {
        return products.map(product =>{
            switch(product.ItemType.Name){
                case "Window":
                    return product.Style.Id;
                case "Door":
                    return product.Type.Id;
                case "Conservatory":
                    return product.Type.Id;
                case "Additional":
                    return product.Type.Id;
                default:
                    return null;
            }
        });
    }
);

export const getDefaultApiKey = (apiKey, loadDGN) => {
    if (!loadDGN) {
        // if we have an api key, storage it in local storage
        if (apiKey && typeof Storage !== undefined) window.sessionStorage.setItem("apiKey", apiKey);

        // if we're passed a key, use it
        if (apiKey) return apiKey;

        // if we have access to local storage
        if (typeof Storage !== undefined) {
            apiKey = window.sessionStorage.getItem("apiKey");
        }

        if (apiKey) return apiKey;
    }
    return "DGN";
};



// WEBPACK FOOTER //
// ./src/selectors/index.js